import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { GalleryComponent } from './gallery.component';
import {
  NguCarousel,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguItemComponent,
  NguTileComponent
} from '@ngu/carousel';
import { MMIconsModule } from '../mm-icons/mm-icons.module';
import { ZoomImageModule } from '../zoom-image/zoom-image.module';
import { SafePipeModule } from '../safePipe/safePipe.module';

@NgModule({
    declarations: [GalleryComponent],
    imports: [
        CommonModule,
        NguCarousel,
        NguTileComponent,
        NguCarouselDefDirective,
        NguCarouselNextDirective,
        NguCarouselPrevDirective,
        NguItemComponent,
        MMIconsModule,
        ZoomImageModule,
        SafePipeModule,
        NgOptimizedImage
    ],
    exports: [GalleryComponent],
    providers: []
})

export class GalleryModule {}
